module.exports = __webpack_public_path__ + "static/img/up-corner-ramp-8m-x-2m_256.61e8250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up-corner-ramp-8m-x-2m_256.png
// module id = qXLs
// module chunks = 0